import React from 'react';

const WhyChooseUs = () => {
    const features = [
        { title: "37+ Years of Experience", desc: "Three generations of packaging craftsmanship refined over decades." },
        { title: "Premium Quality Materials", desc: "Virgin-grade and recycled boards chosen for durability and finish." },
        { title: "Custom Packaging Solutions", desc: "From bespoke sizes to custom foiling — we build to your vision." },
        { title: "Competitive Pricing", desc: "Direct-from-manufacturer pricing with no middlemen." },
        { title: "Trusted by Thousands", desc: "A loyal client base across retail, FMCG, weddings and corporates." },
        { title: "Export-Quality Standards", desc: "Strict quality control and packaging for global shipment." }
    ];

    return (
        <section className="bg-[#fdfcfb] border-y border-[#e5e5e5] 
py-12 md:py-16 lg:py-12
lg:min-h-[calc(100vh-90px)] lg:flex lg:items-center">

            <div className="container-x h-full flex flex-col">

                <div className="grid md:grid-cols-12 gap-8 md:gap-10 w-full">

                    {/* LEFT */}
                    <div className="md:col-span-4 flex flex-col">

                        {/* Top Label */}
                        <div className="flex flex-col mb-4">
                            <span className="h-[1.5px] w-16 bg-brand-gold mb-2"></span>
                            <p className="text-[11px] uppercase tracking-[0.3em] text-brand-gold font-bold">
                                Why Choose Us
                            </p>
                        </div>

                        {/* Heading */}
                        <h2 className="mt-2 font-serif text-[30px] sm:text-[36px] md:text-[48px] lg:text-[52px] leading-[1.05] text-brand-dark">
                            Craft that <br />
                            <span className="italic text-brand-brown">earns trust.</span>
                        </h2>

                        {/* Description */}
                        <p className="mt-4 md:mt-5 text-gray-600 leading-relaxed max-w-md">
                            For over three decades, Famous Packing has focused on quality, clean design,
                            and fair pricing. We create packaging that not only looks good but also feels
                            right for every occasion — from sweet boxes to corporate gifts. Our goal has
                            always been simple: make products that people trust and come back for.
                        </p>

                        {/* NEW ADDITION (STAT BLOCK) */}
                        <div className="mt-6 md:mt-8 flex items-center gap-4">
                            <div className="text-brand-brown font-serif text-[32px] md:text-[36px]">
                                37+
                            </div>
                            <div className="text-sm text-brand-gold font-bold leading-tight">
                                Years of Excellence in <br /> Packaging Industry
                            </div>
                        </div>

                    </div>

                    {/* RIGHT GRID */}
                    <div className="md:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#e5e5e5]">

                        {features.map((f, i) => (
                            <div key={i} className="bg-[#fdfcfb] p-5 md:p-6 flex gap-4">
                                <div className="shrink-0 h-10 w-10 border border-brand-gold flex items-center justify-center text-brand-gold">
                                    ★
                                </div>

                                <div>
                                    <h4 className="font-serif text-[15px] md:text-[18px] text-brand-brown font-bold">
                                        {f.title}
                                    </h4>
                                    <p className="mt-1 text-sm text-black leading-relaxed">
                                        {f.desc}
                                    </p>
                                </div>
                            </div>
                        ))}

                    </div>

                </div>

            </div>
        </section>
    );
};

export default WhyChooseUs;